// Indigenous identity options with prefixed IDs to indicate their type
export const CANDIAN_INDIGENOUS_OPTIONS = [
  {
    id: "indigenous-000-n1fxyb",
    label: "No, not First Nations, Métis or Inuk (Inuit)",
  },
  {
    id: "indigenous-001-b2flxl",
    label: "Yes, First Nations (North American Indian)",
  },
  { id: "indigenous-002-d2x7ku", label: "Yes, Métis" },
  { id: "indigenous-003-pio8w4", label: "Yes, Inuk (Inuit)" },
];

// Combined ethnicity options with prefixed IDs to indicate their type and slot
export const ETHNICITY_OPTIONS = [
  { id: "eth1-001-9a30j", id2: "eth2-000-n02oc6", label: "White" },
  {
    id: "eth1-001-drrtn",
    id2: "eth2-001-8unt2",
    label: "South Asian (e.g., East Indian, Pakistani, Sri Lankan)",
  },
  { id: "eth1-002-kk7n5v", id2: "eth2-002-8hjk9y", label: "Chinese" },
  { id: "eth1-003-gvwgt", id2: "eth2-003-10q2o", label: "Black" },
  { id: "eth1-004-xa7rq", id2: "eth2-004-rer778", label: "Filipino" },
  { id: "eth1-005-mybp1s", id2: "eth2-005-lmytkb", label: "Arab" },
  { id: "eth1-006-i1pbsb", id2: "eth2-006-92ezdk", label: "Latin American" },
  {
    id: "eth1-007-cnibbv",
    id2: "eth2-007-dtygqb",
    label: "Southeast Asian (e.g., Vietnamese, Cambodian, Laotian, Thai)",
  },
  {
    id: "eth1-008-k3wrrp",
    id2: "eth2-008-oxqvff",
    label: "West Asian (e.g., Iranian, Afghan)",
  },
  { id: "eth1-009-ee1tf", id2: "eth2-009-c5m14", label: "Korean" },
  { id: "eth1-010-a85ghf", id2: "eth2-010-3c7znu", label: "Japanese" },
  { id: "eth1-011-ilo4nh", id2: "eth2-011-2p1jo8", label: "Other" },
  {
    id: "eth1-012-0hgvzo",
    id2: "eth2-012-r039zx",
    label: "I'd prefer not to answer",
  },
];
